import { Component, Input } from '@angular/core';
import { IOdbBillProductSplit } from '@dch/billing-business-logic';

interface ISettlementSection {
  labelKey: string;
  amount: string;
}

@Component({
  selector: 'my-bill-odb-settlement-product-split',
  templateUrl: './odb-settlement-product-split.component.html',
  standalone: false,
})
export class OdbSettlementProductSplitComponent {
  @Input() productSplit: Array<IOdbBillProductSplit>;
  @Input() totalAmount: string;

  get sections(): Array<ISettlementSection> {
    const displaysVersion2 = this.productSplit.length !== 0;

    return displaysVersion2
      ? this.productSplit.flatMap((productSplit) =>
          productSplit.categoryDetails.flatMap((categoryDetail) =>
            categoryDetail.sections.map((section) => ({
              labelKey: `bills.cover.odbDetails.settlement.${section.type}Label`,
              amount: section.amount,
            }))
          )
        )
      : [
          {
            labelKey: 'bills.cover.odbDetails.settlement.v1GenericLabel',
            amount: this.totalAmount,
          },
        ];
  }
}
